export const GET_USERS_EMAILS = "GET_USERS_EMAILS";
export const SEND_GLOBAL_NOTIFICATION = "SEND_GLOBAL_NOTIFICATION";
export const SEND_USER_NOTIFICATION = "SEND_USER_NOTIFICATION";